export const safeEvidenceUrl = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && (!url.port || url.port === '443') &&
      ['gemstoneitservices.sharepoint.com', 'gemstoneit.atlassian.net', 'codex.gemstoneit.co.uk', 'gcm.gem.li', 'test.gcm.gem.li'].includes(url.hostname) &&
      !Array.from(url.searchParams.keys()).some((key) => /token|signature|credential|secret|password|^(code|sig)$/i.test(key)) ? value : null;
  } catch { return null; }
};
